/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Articles_TInputs */

const en_funnel_ob_seg_articles_t = /** @type {(inputs: Funnel_Ob_Seg_Articles_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles & news`)
};

const es_funnel_ob_seg_articles_t = /** @type {(inputs: Funnel_Ob_Seg_Articles_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos y noticias`)
};

/**
* | output |
* | --- |
* | "Articles & news" |
*
* @param {Funnel_Ob_Seg_Articles_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_articles_t = /** @type {((inputs?: Funnel_Ob_Seg_Articles_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Articles_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_articles_t(inputs)
	return en_funnel_ob_seg_articles_t(inputs)
});